import { ICustomer } from '@data/interfaces/customer/customer.interface';

export class Customer {
  salesForceId: string;
  name: string;
  constructor(data: ICustomer) {
    Object.assign(this, data);
  }
}
